var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIcon = function SvgIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 104,
    viewBox: "0 0 152 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_542_308)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.3887 26.6981C87.5695 13.7997 106.063 13.76 114.297 26.6232L127.622 47.4391C136.311 61.0128 126.759 79 110.862 79H37.0379C24.2888 79 16.6535 64.5467 23.6681 53.6919L34.6023 36.772C41.289 26.4246 56.2027 26.5073 62.7786 36.9284L67.8264 44.9279L79.3887 26.6981ZM63.0545 52.4515L56.0462 41.3451C52.6016 35.8865 44.7897 35.8431 41.2871 41.2632L30.353 58.1832C26.8457 63.6106 30.6634 70.8372 37.0379 70.8372H51.3934L63.0545 52.4515ZM60.9272 70.8372L67.8092 59.9865L74.6563 70.8372H60.9272ZM84.1758 70.8372L72.5812 52.4628L86.111 31.1309C91.1454 23.1934 102.526 23.1689 107.593 31.0847L120.918 51.9007C126.131 60.0449 120.4 70.8372 110.862 70.8372H84.1758Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.381 26.5693C106.108 13.6445 87.5243 13.6844 79.3043 26.6446L67.8267 44.7408L62.8632 36.875C56.2483 26.3922 41.2447 26.3089 34.5183 36.7177L23.5841 53.6377C16.5284 64.5561 24.2061 79.1 37.0379 79.1H110.862C126.841 79.1 136.436 61.0225 127.706 47.3852L114.381 26.5693ZM55.9616 41.3985L62.9362 52.4514L51.3384 70.7372H37.0379C30.7461 70.7372 26.9708 63.6013 30.437 58.2375L41.3711 41.3175C44.834 35.9588 52.556 36.0016 55.9616 41.3985ZM74.4749 70.7372H61.109L67.809 60.1736L74.4749 70.7372ZM110.862 70.7372H84.2309L72.6995 52.463L86.1955 31.1844C91.1907 23.3087 102.481 23.2845 107.509 31.1386L120.834 51.9546C126.006 60.0352 120.318 70.7372 110.862 70.7372Z",
    stroke: "url(#paint0_linear_542_308)",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.381 26.5693C106.108 13.6445 87.5243 13.6844 79.3043 26.6446L67.8267 44.7408L62.8632 36.875C56.2483 26.3922 41.2447 26.3089 34.5183 36.7177L23.5841 53.6377C16.5284 64.5561 24.2061 79.1 37.0379 79.1H110.862C126.841 79.1 136.436 61.0225 127.706 47.3852L114.381 26.5693ZM55.9616 41.3985L62.9362 52.4514L51.3384 70.7372H37.0379C30.7461 70.7372 26.9708 63.6013 30.437 58.2375L41.3711 41.3175C44.834 35.9588 52.556 36.0016 55.9616 41.3985ZM74.4749 70.7372H61.109L67.809 60.1736L74.4749 70.7372ZM110.862 70.7372H84.2309L72.6995 52.463L86.1955 31.1844C91.1907 23.3087 102.481 23.2845 107.509 31.1386L120.834 51.9546C126.006 60.0352 120.318 70.7372 110.862 70.7372Z",
    stroke: "white",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_542_308",
    x: 0.800781,
    y: 0.799805,
    width: 150.309,
    height: 102.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.89325 0 0 0 0 0.2375 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_542_308"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_542_308",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_542_308",
    x1: 22.1215,
    y1: 50.7219,
    x2: 130.91,
    y2: 50.9341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8422E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBAE3C"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.ed4925532e599faa3b479096d620a329.svg";